<template>
  <px-span-tooltip top
                   :text="labelCompra"
                   :tooltip="tooltipCompra"/>
</template>

<script>
export default {
  props: {
    compra: {
      type: Object,
      required: true,
    },
    prefix: {
      type: String,
      default: '',
    },
  },
  computed: {
    labelCompra() {
      return this.compra.codigoInterno ? `${this.prefix}${this.compra.codigoInterno} / ${this.compra.id}` : `${this.prefix}${this.compra.id}`;
    },
    tooltipCompra() {
      return this.compra.codigoInterno ? 'Pedido de OC gerada / Pedido Proxpect' : 'Pedido Proxpect';
    },
  },
};
</script>
